import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/background.module.scss'
import classNames from 'classnames'

type Props = {
  children?: ReactNode
  color: 'grey'
}

const Background: FC<Props> = (props) => {
  const { children, color } = props
  return (
    <section
      className={classNames({
        [styles.background_grey]: color === 'grey',
      })}
    >
      {children}
    </section>
  )
}

export default Background
